export default __webpack_public_path__ + "static/media/movie.1814157c.png";